import { lazyOpenDiagnostics } from 'hybridspace-diagnostics';
import getApplicationSettings from 'owa-application-settings/lib/selectors/getApplicationSettings';
import { useGlobalHotkey } from 'owa-hotkeys';

export default function usePlacesGlobalHotkey(): void {
    useGlobalHotkey('alt+shift+d', lazyOpenDiagnostics.importAndExecute, {
        isEnabled: () => getApplicationSettings('Diagnostics').panel,
    });
}
